import { Component, EventEmitter, Input, Output } from '@angular/core';
import { speedDialFabAnimations } from './speed-dial-fab.animations';

export interface FabButton {
  icon: string,
  tooltip: string
}

@Component({
    selector: 'speed-dial-fab',
    templateUrl: './speed-dial-fab.component.html',
    styleUrls: ['./speed-dial-fab.component.scss'],
    animations: speedDialFabAnimations,
    standalone: false
})
export class SpeedDialFabComponent {

  @Input() reverseColumnDirection = false;
  @Input() fabButtons: FabButton[];
  @Output() fabClick = new EventEmitter();

  buttons = [];
  subButtons = [];
  activeButton;
  fabTogglerState = 'inactive';

  constructor() {
  }

  public onToggleFab() {
    this.buttons.length ? this.hideItems() : this.showItems();
  }

  public onClickFab(btn: any) {
    if (btn.buttons && btn.buttons.length === 1 && btn.buttons[0].title === 'Default') {
      this.hideItems();
      this.fabClick.emit({ group: btn.title, module: 'Default' });
    } else {
      this.activeButton = btn;
      this.subButtons = btn.buttons
    }
  }

  public onClickSubFab(btn) {
    this.fabClick.emit({ group: this.activeButton.title, module: btn.title });
    this.hideItems();
  }

  private showItems() {
    this.fabTogglerState = 'active';
    this.buttons = this.fabButtons;
  }

  private hideItems() {
    this.fabTogglerState = 'inactive';
    this.activeButton = undefined;
    this.buttons = [];
    this.subButtons = [];
  }
}
